import { useTranslation } from 'react-i18next';

import { Text } from 'components/library';

import * as S from './styled';

type Props = { title: string; Badge: string; bodyText: string };

const ReasonCard = ({ title, Badge, bodyText }: Props) => {
    const { t } = useTranslation();

    return (
        <S.Container>
            <S.Header>
                <Badge />
                <Text type="large-text">{t(title)}</Text>
            </S.Header>

            <Text type="small-text">{t(bodyText)}</Text>
        </S.Container>
    );
};

export default ReasonCard;
